// // ===========================================
// // Multi GWP Sync (supports multiple independent GWPs)
// // Perf + Reliability hardened version
// // ===========================================

// (() => {
//   // --------------------
//   // Guard against double-loading
//   // --------------------
//   if (window.__MULTI_GWP_SYNC_INIT__) return;
//   window.__MULTI_GWP_SYNC_INIT__ = true;

//   // --------------------
//   // CONFIG
//   // --------------------
//   const DEBUG_GWP = false;
//   const log = (...a) => DEBUG_GWP && console.log("[MultiGWP]", ...a);
//   const warn = (...a) => DEBUG_GWP && console.warn("[MultiGWP]", ...a);

//   /**
//    * Rules:
//    * - qualifiers: variant IDs that qualify for the GWP
//    * - gwpVariantId: the GWP variant to add/sync/remove
//    * - qtyMode:
//    *    - "sum": GWP qty = sum of all qualifying item quantities
//    *    - "bool": GWP qty = 1 if any qualifying item is present (only one per order)
//    */
//   const GWP_RULES = [
//     {
//       name: "FireHorseGWP",
//       qualifiers: ["56087469850790"], // Hold Your Fire Horses bundle
//       gwpVariantId: "56189984080038", // Set of red envelopes
//       qtyMode: "sum",
//     },
//     {
//       name: "PastelHookGWP",
//       qualifiers: [
//         "56169901621414",
//         "56169987145894",
//         "56168798879910",
//         "44807518486694",
//         "44696494473382",
//         "44680546451622",
//         "44680541700262",
//       ],
//       gwpVariantId: "44811311251622", // Pastel crochet hook
//       qtyMode: "bool", // only ONE per order if any qualifier exists
//     },
//   ];

//   // --------------------
//   // Tunables (performance + stability)
//   // --------------------
//   const CART_ENDPOINTS = {
//     get: "/cart.js",
//     add: "/cart/add.js",
//     change: "/cart/change.js",
//   };

//   // Debounce time for DOM-triggered enforcement
//   const ENFORCE_DEBOUNCE_MS = 250;

//   // Post-mutation verification delay (gives SlideCart time to rerender)
//   const VERIFY_AFTER_CHANGE_MS = 650;

//   // Mutation retries
//   const MUTATION_TRIES = 3;
//   const MUTATION_BACKOFF_MS = 250;

//   // Initial “settle” read retries (helps when cart isn’t ready yet)
//   const INITIAL_CART_READ_RETRIES = 12;
//   const INITIAL_CART_READ_DELAY = 300;

//   // Subsequent reads are lighter
//   const NORMAL_CART_READ_RETRIES = 4;
//   const NORMAL_CART_READ_DELAY = 200;

//   // --------------------
//   // Shared helpers
//   // --------------------
//   const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

//   async function fetchJson(url, options = {}) {
//     const res = await fetch(url, {
//       credentials: "same-origin",
//       ...options,
//     });
//     // We still attempt to parse JSON for debugging when possible
//     let data = null;
//     try {
//       data = await res.json();
//     } catch (e) {
//       // ignore
//     }
//     return { res, data };
//   }

//   async function getCart() {
//     const { res, data } = await fetchJson(CART_ENDPOINTS.get);
//     if (!res.ok) throw new Error(`getCart failed: HTTP ${res.status}`);
//     return data;
//   }

//   async function getCartWithOptionalWait(retries, delay) {
//     for (let i = 0; i < retries; i++) {
//       try {
//         const cart = await getCart();
//         if (cart && Array.isArray(cart.items)) return cart;
//       } catch (e) {
//         // swallow and retry
//       }
//       await sleep(delay);
//     }
//     return getCart();
//   }

//   async function withRetry(fn, tries = MUTATION_TRIES, baseWait = MUTATION_BACKOFF_MS) {
//     let lastErr;
//     for (let i = 0; i < tries; i++) {
//       try {
//         const out = await fn();
//         // If fn returns fetch Response, require ok
//         if (out && typeof out.ok === "boolean") {
//           if (out.ok) return out;
//           lastErr = new Error(`HTTP ${out.status}`);
//         } else {
//           // Otherwise assume success
//           return out;
//         }
//       } catch (e) {
//         lastErr = e;
//       }
//       await sleep(baseWait * (i + 1));
//     }
//     throw lastErr;
//   }

//   async function addVariant(variantId, quantity) {
//     log("Attempting to add variant", { variantId, quantity });

//     const res = await fetch(CART_ENDPOINTS.add, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       credentials: "same-origin",
//       body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
//     });

//     if (DEBUG_GWP && !res.ok) {
//       let text = "";
//       try {
//         text = await res.text();
//       } catch {}
//       warn("FAILED to add variant", { variantId, quantity, status: res.status, text });
//     }

//     return res;
//   }

//   async function setLineQuantity(lineKey, quantity) {
//     const res = await fetch(CART_ENDPOINTS.change, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       credentials: "same-origin",
//       body: JSON.stringify({ id: lineKey, quantity }),
//     });

//     if (DEBUG_GWP && !res.ok) {
//       let text = "";
//       try {
//         text = await res.text();
//       } catch {}
//       warn("FAILED to change line qty", { lineKey, quantity, status: res.status, text });
//     }

//     return res;
//   }

//   // --------------------
//   // UI lock (SlideCart + theme cart qty controls)
//   // --------------------
//   function disableQuantityControls(variantId) {
//     const vid = String(variantId);

//     // AMP SlideCart item rows (if present)
//     document.querySelectorAll(`[data-variant-id="${vid}"]`).forEach((line) => {
//       const dec = line.querySelector('button[aria-label="decrease quantity"]');
//       const inc = line.querySelector('button[aria-label="increase quantity"]');
//       const input = line.querySelector(
//         ".quantity-selector input[type='text'], .quantity-selector input[type='number']"
//       );

//       if (dec) {
//         dec.disabled = true;
//         dec.setAttribute("aria-disabled", "true");
//         dec.classList.add("gwp-locked");
//       }
//       if (inc) {
//         inc.disabled = true;
//         inc.setAttribute("aria-disabled", "true");
//         inc.classList.add("gwp-locked");
//       }
//       if (input) {
//         input.readOnly = true;
//         input.classList.add("gwp-locked");
//       }
//     });

//     // Theme cart inputs (if present)
//     document.querySelectorAll(".cart__qty-input").forEach((input) => {
//       const match = input.id && input.id.match(/updates_large_(\d+)/);
//       if (match && match[1] === vid) {
//         input.readOnly = true;
//         input.classList.add("gwp-locked");
//       }
//     });
//   }

//   // --------------------
//   // Rule helpers
//   // --------------------
//   function getDesiredGwpQty(cart, qualifiers, qtyMode) {
//     const qualifierSet = new Set(qualifiers.map(String));

//     const qualifyingQty = (cart.items || [])
//       .filter((i) => qualifierSet.has(String(i.variant_id)))
//       .reduce((sum, i) => sum + (i.quantity || 0), 0);

//     if (qtyMode === "bool") return qualifyingQty > 0 ? 1 : 0;
//     return qualifyingQty; // "sum"
//   }

//   function buildVariantMap(cart) {
//     const byVariant = new Map();
//     for (const item of cart.items || []) {
//       const vid = String(item.variant_id);
//       if (!byVariant.has(vid)) byVariant.set(vid, item);
//     }
//     return byVariant;
//   }

//   // --------------------
//   // Enforcement logic (all GWPs)
//   // --------------------
//   let firstEnforcement = true;
//   let enforcing = false;
//   let pending = false;

//   async function enforceAllGwpRules({ longWait = false, reason = "unknown" } = {}) {
//     if (enforcing) {
//       pending = true;
//       log("Enforcement requested while enforcing; marking pending rerun.", { reason });
//       return;
//     }

//     enforcing = true;
//     pending = false;

//     try {
//       log("Enforcing all GWP rules…", { reason });

//       const retries = longWait || firstEnforcement ? INITIAL_CART_READ_RETRIES : NORMAL_CART_READ_RETRIES;
//       const delay = longWait || firstEnforcement ? INITIAL_CART_READ_DELAY : NORMAL_CART_READ_DELAY;

//       const cart = await getCartWithOptionalWait(retries, delay);
//       firstEnforcement = false;

//       const byVariant = buildVariantMap(cart);

//       let didChange = false;

//       // Process rules sequentially (stable, predictable)
//       for (const rule of GWP_RULES) {
//         const name = rule.name || "GWP";
//         const qualifiers = (rule.qualifiers || []).map(String);
//         const gwpVariantId = String(rule.gwpVariantId || "");
//         const qtyMode = rule.qtyMode || "sum";

//         if (!gwpVariantId || !qualifiers.length) {
//           warn(`${name}: missing gwpVariantId or qualifiers, skipping`, rule);
//           continue;
//         }

//         const desiredQty = getDesiredGwpQty(cart, qualifiers, qtyMode);
//         const gwpItem = byVariant.get(gwpVariantId);

//         log(`${name}: desiredQty=${desiredQty}`, { gwpVariantId, qtyMode });

//         // If no longer qualifies, remove the gift
//         if (desiredQty <= 0) {
//           if (gwpItem) {
//             log(`${name}: removing GWP (no qualifiers in cart)`);
//             await withRetry(() => setLineQuantity(gwpItem.key, 0));
//             didChange = true;
//           }
//           continue;
//         }

//         // Qualifies: ensure gift exists
//         if (!gwpItem) {
//           log(`${name}: adding GWP qty=${desiredQty}`);
//           await withRetry(() => addVariant(gwpVariantId, desiredQty));
//           didChange = true;
//           continue;
//         }

//         // Qualifies: ensure qty matches desired
//         if ((gwpItem.quantity || 0) !== desiredQty) {
//           log(`${name}: syncing GWP qty ${gwpItem.quantity} → ${desiredQty}`);
//           await withRetry(() => setLineQuantity(gwpItem.key, desiredQty));
//           didChange = true;
//         }

//         // Lock the gift line controls
//         disableQuantityControls(gwpVariantId);
//       }

//       // Refresh SlideCart once at end if cart changed
//       if (didChange) {
//         window.SLIDECART_UPDATE?.();

//         // Verify after rerender / async cart reconciliation
//         scheduleEnforcement(VERIFY_AFTER_CHANGE_MS, "verify_after_change");
//       } else {
//         // Still lock controls after rerenders
//         for (const rule of GWP_RULES) {
//           if (rule?.gwpVariantId) disableQuantityControls(String(rule.gwpVariantId));
//         }
//       }
//     } catch (e) {
//       warn("GWP enforcement error", e);
//     } finally {
//       enforcing = false;

//       // Critical: never drop triggers that happen mid-run
//       if (pending) {
//         pending = false;
//         log("Running pending enforcement pass…");
//         // Run immediately (no longWait) to catch missed updates
//         enforceAllGwpRules({ longWait: false, reason: "pending_rerun" });
//       }
//     }
//   }

//   // --------------------
//   // Debounced scheduling
//   // --------------------
//   let enforceTimeout = null;
//   function scheduleEnforcement(delay = ENFORCE_DEBOUNCE_MS, reason = "debounced") {
//     clearTimeout(enforceTimeout);
//     enforceTimeout = setTimeout(() => enforceAllGwpRules({ longWait: false, reason }), delay);
//   }

//   // --------------------
//   // Observer (scoped to SlideCart if present)
//   // --------------------
//   function getObserverTarget() {
//     // Prefer SlideCart root if available; falls back to body.
//     return document.querySelector("#slidecarthq") || document.querySelector(".slidecarthq") || document.body;
//   }

//   let gwpObserver = null;
//   function startObserver() {
//     if (gwpObserver) return;

//     const target = getObserverTarget();
//     gwpObserver = new MutationObserver(() => scheduleEnforcement(ENFORCE_DEBOUNCE_MS, "mutation"));
//     gwpObserver.observe(target, { childList: true, subtree: true });

//     log("GWP observer started", { target: target === document.body ? "body" : "slidecart-root" });
//   }

//   // If SlideCart root appears later, we can re-scope observer once
//   let rescopeDone = false;
//   function rescopeObserverIfNeeded() {
//     if (rescopeDone) return;
//     const slidecartRoot = document.querySelector("#slidecarthq") || document.querySelector(".slidecarthq");
//     if (!slidecartRoot) return;

//     try {
//       gwpObserver?.disconnect?.();
//     } catch {}
//     gwpObserver = null;

//     startObserver();
//     rescopeDone = true;
//   }

//   // --------------------
//   // Init
//   // --------------------
//   function init() {
//     startObserver();

//     // If SlideCart loads after DOMContentLoaded, re-scope once
//     const initObserver = new MutationObserver(() => rescopeObserverIfNeeded());
//     initObserver.observe(document.documentElement, { childList: true, subtree: true });
//     setTimeout(() => {
//       try { initObserver.disconnect(); } catch {}
//     }, 4000);

//     // Initial run (long wait)
//     enforceAllGwpRules({ longWait: true, reason: "init" });
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", init);
//   } else {
//     init();
//   }
// })();

// ===========================================
// Multi GWP Sync
// - Pastel Hook: exact one-per-order GWP
// - Farewell Eyes: dynamic max-cap GWP
//
// Cart page updates added:
// - Locks quantity inputs/buttons/remove controls for all GWP variants in GWP_RULES
// - Blocks cart-page GWP quantity/remove actions before theme JS can mutate cart
// - Ensures GWP quantity never exceeds its allowed qualifying quantity
// ===========================================

(() => {
  if (window.__MULTI_GWP_SYNC_INIT__) return;
  window.__MULTI_GWP_SYNC_INIT__ = true;

  const DEBUG_GWP = false;
  const log = (...a) => DEBUG_GWP && console.log("[MultiGWP]", ...a);
  const warn = (...a) => DEBUG_GWP && console.warn("[MultiGWP]", ...a);

  /**
   * syncMode:
   * - "exact": force GWP qty to desired qty
   * - "max": GWP qty cannot exceed desired qty, but shopper may choose less
   *
   * qtyMode:
   * - "sum": desired/max qty = total quantity of qualifying variants in cart
   * - "bool": desired/max qty = 1 if any qualifying variant is in cart
   */
  const GWP_RULES = [
    // {
    //   name: "PastelHookGWP",
    //   qualifiers: [
    //     "56169901621414",
    //     "56169987145894",
    //     "56168798879910",
    //     "44807518486694",
    //     "44696494473382",
    //     "44680546451622",
    //     "44680541700262",
    //   ],
    //   gwpVariantId: "44811311251622",
    //   qtyMode: "bool",
    //   syncMode: "exact",
    // },
    {
      name: "FarewellEyesGWP",
      qualifiers: [
        "44018465702054",
        "44054249275558",
        "45621089239206",
        "46057067970726",
        "45044179173542",
        "46274105606310",
        "56080875618470",
        "45712588439718",
        "46329673744550",
        "45977774293158",
        "46365343908006",
        "45903719596198",
        "45903699345574",
        "45903682633894",
        "45903683190950",
      ],
      gwpVariantId: "56424938143910",
      qtyMode: "sum",
      syncMode: "max",

      // Before the shopper opts out, keep the GWP synced up to the dynamic max.
      // Once they decrease/remove/edit the GWP in this session, stop auto-increasing it.
      autoSyncUpToMax: true,
    },
  ];

  const CART_ENDPOINTS = {
    get: "/cart.js",
    add: "/cart/add.js",
    change: "/cart/change.js",
  };

  const ENFORCE_DEBOUNCE_MS = 250;
  const VERIFY_AFTER_CHANGE_MS = 650;

  const MUTATION_TRIES = 3;
  const MUTATION_BACKOFF_MS = 250;

  const INITIAL_CART_READ_RETRIES = 12;
  const INITIAL_CART_READ_DELAY = 300;

  const NORMAL_CART_READ_RETRIES = 4;
  const NORMAL_CART_READ_DELAY = 200;

  // Session-level opt-out, aligned with AMP Slide Cart's one-auto-add-per-session behavior.
  const MANUAL_LOWER_STORAGE_KEY = "multi_gwp_manual_lower_variants_v1";

  const CART_PAGE_LOCKED_ATTR = "data-gwp-cart-page-locked";

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  async function fetchJson(url, options = {}) {
    const res = await fetch(url, {
      credentials: "same-origin",
      ...options,
    });

    let data = null;

    try {
      data = await res.json();
    } catch (e) {
      // ignore
    }

    return { res, data };
  }

  async function getCart() {
    const { res, data } = await fetchJson(CART_ENDPOINTS.get);
    if (!res.ok) throw new Error(`getCart failed: HTTP ${res.status}`);
    return data;
  }

  async function getCartWithOptionalWait(retries, delay) {
    for (let i = 0; i < retries; i++) {
      try {
        const cart = await getCart();
        if (cart && Array.isArray(cart.items)) return cart;
      } catch (e) {
        // retry
      }

      await sleep(delay);
    }

    return getCart();
  }

  async function withRetry(fn, tries = MUTATION_TRIES, baseWait = MUTATION_BACKOFF_MS) {
    let lastErr;

    for (let i = 0; i < tries; i++) {
      try {
        const out = await fn();

        if (out && typeof out.ok === "boolean") {
          if (out.ok) return out;
          lastErr = new Error(`HTTP ${out.status}`);
        } else {
          return out;
        }
      } catch (e) {
        lastErr = e;
      }

      await sleep(baseWait * (i + 1));
    }

    throw lastErr;
  }

  async function addVariant(variantId, quantity) {
    log("Adding variant", { variantId, quantity });

    return fetch(CART_ENDPOINTS.add, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({
        items: [{ id: variantId, quantity }],
      }),
    });
  }

  async function setLineQuantity(lineKey, quantity) {
    log("Setting line quantity", { lineKey, quantity });

    return fetch(CART_ENDPOINTS.change, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({
        id: lineKey,
        quantity,
      }),
    });
  }

  // --------------------
  // Session opt-out helpers
  // --------------------
  function readManualLowerSet() {
    try {
      const raw = sessionStorage.getItem(MANUAL_LOWER_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return new Set(Array.isArray(parsed) ? parsed.map(String) : []);
    } catch {
      return new Set();
    }
  }

  function writeManualLowerSet(set) {
    try {
      sessionStorage.setItem(MANUAL_LOWER_STORAGE_KEY, JSON.stringify([...set]));
    } catch {
      // ignore
    }
  }

  function isManuallyLowered(variantId) {
    return readManualLowerSet().has(String(variantId));
  }

  function setManuallyLowered(variantId, value) {
    const set = readManualLowerSet();
    const vid = String(variantId);

    if (value) {
      set.add(vid);
    } else {
      set.delete(vid);
    }

    writeManualLowerSet(set);
  }

  // --------------------
  // Cart helpers
  // --------------------
  function getQualifyingQty(cart, qualifiers) {
    const qualifierSet = new Set(qualifiers.map(String));

    return (cart.items || [])
      .filter((item) => qualifierSet.has(String(item.variant_id)))
      .reduce((sum, item) => sum + (item.quantity || 0), 0);
  }

  function getAllowedQty(cart, qualifiers, qtyMode) {
    const qualifyingQty = getQualifyingQty(cart, qualifiers);

    if (qtyMode === "bool") return qualifyingQty > 0 ? 1 : 0;

    // Farewell Eyes uses this dynamic max:
    // max allowance = total quantity of qualifying items currently in cart.
    return qualifyingQty;
  }

  function getVariantLines(cart, variantId) {
    const vid = String(variantId);
    return (cart.items || []).filter((item) => String(item.variant_id) === vid);
  }

  function getTotalQty(items) {
    return items.reduce((sum, item) => sum + (item.quantity || 0), 0);
  }

  async function syncVariantLinesToQuantity(items, desiredTotalQty) {
    if (!items.length) return;

    const [primaryItem, ...duplicateItems] = items;

    await withRetry(() => setLineQuantity(primaryItem.key, desiredTotalQty));

    for (const item of duplicateItems) {
      await withRetry(() => setLineQuantity(item.key, 0));
    }
  }

  function getAllGwpVariantIds() {
    return GWP_RULES.map((rule) => String(rule.gwpVariantId || "")).filter(Boolean);
  }

  function isGwpVariantId(variantId) {
    const vid = String(variantId || "");
    return getAllGwpVariantIds().includes(vid);
  }

  // --------------------
  // Shared UI control helpers
  // --------------------
  function setControlDisabled(control, disabled) {
    if (!control) return;

    const tagName = control.tagName ? control.tagName.toLowerCase() : "";

    if (tagName === "button" || tagName === "select") {
      control.disabled = disabled;
    }

    if (tagName === "input" || tagName === "textarea") {
      control.readOnly = disabled;
      control.setAttribute("readonly", disabled ? "readonly" : "");
    }

    if (disabled) {
      control.setAttribute("aria-disabled", "true");
      control.classList.add("gwp-locked");
    } else {
      control.removeAttribute("aria-disabled");
      control.classList.remove("gwp-locked");

      if (tagName === "input" || tagName === "textarea") {
        control.removeAttribute("readonly");
      }
    }
  }

  function isInsideSlideCart(element) {
    return Boolean(
      element &&
        element.closest &&
        element.closest("#slidecarthq, .slidecarthq, [data-slidecart], [data-slide-cart]")
    );
  }

  function isLikelyCartPageElement(element) {
    if (!element || !(element instanceof Element)) return false;
    if (isInsideSlideCart(element)) return false;

    return Boolean(
      element.closest(
        [
          "form[action*='/cart']",
          "form[action*=\"/cart\"]",
          "cart-items",
          "#main-cart-items",
          ".cart",
          ".cart-page",
          ".template-cart",
          "[data-cart-page]",
        ].join(",")
      )
    );
  }

  function getLineItemRoot(element) {
    if (!element || !(element instanceof Element)) return null;

    return (
      element.closest(
        [
          ".cart-item",
          ".cart__row",
          ".cart__item",
          ".cart-items__row",
          ".line-item",
          "[data-cart-item]",
          "[data-line-item]",
          "tr",
          "li",
        ].join(",")
      ) || element
    );
  }

  // --------------------
  // SlideCart controls
  // --------------------
  function getSlideCartRowsForVariant(variantId) {
    return document.querySelectorAll(`[data-variant-id="${String(variantId)}"]`);
  }

  function lockExactQuantityControls(variantId) {
    getSlideCartRowsForVariant(variantId).forEach((line) => {
      const dec = line.querySelector('button[aria-label="decrease quantity"]');
      const inc = line.querySelector('button[aria-label="increase quantity"]');
      const input = line.querySelector(
        ".quantity-selector input[type='text'], .quantity-selector input[type='number']"
      );

      setControlDisabled(dec, true);
      setControlDisabled(inc, true);

      if (input) {
        input.readOnly = true;
        input.setAttribute("readonly", "readonly");
        input.classList.add("gwp-locked");
      }
    });

    // Cart page locking is handled separately and more broadly below.
  }

  function applyMaxQuantityControls(variantId, currentQty, maxQty) {
    const safeCurrentQty = Number(currentQty || 0);
    const safeMaxQty = Number(maxQty || 0);
    const atMax = safeMaxQty > 0 && safeCurrentQty >= safeMaxQty;

    getSlideCartRowsForVariant(variantId).forEach((line) => {
      const dec = line.querySelector('button[aria-label="decrease quantity"]');
      const inc = line.querySelector('button[aria-label="increase quantity"]');
      const input = line.querySelector(
        ".quantity-selector input[type='text'], .quantity-selector input[type='number']"
      );

      // Shopper may choose fewer than their max allowance in SlideCart.
      setControlDisabled(dec, false);

      // Shopper may not go above their dynamic max allowance.
      setControlDisabled(inc, atMax);

      if (input) {
        input.readOnly = false;
        input.removeAttribute("readonly");
        input.max = String(safeMaxQty);
        input.setAttribute("max", String(safeMaxQty));
        input.classList.remove("gwp-locked");
        input.classList.add("gwp-max-capped");
      }
    });

    // Cart page locking is handled separately and more broadly below.
  }

  // --------------------
  // Cart page controls
  // --------------------
  function getCartPageQuantityInputs() {
    return [...document.querySelectorAll(
      [
        ".cart__qty-input",
        "input.quantity__input",
        "input[name='updates[]']",
        "input[name^='updates[']",
        "input[id^='Quantity-']",
        "input[id^='updates_']",
        "input[id^='updates_large_']",
        "input[data-quantity-variant-id]",
      ].join(",")
    )].filter(isLikelyCartPageElement);
  }

  function getCartPageRowsForVariant(variantId, cart) {
    const vid = String(variantId);
    const rows = new Set();

    // Direct variant-id selectors. These catch many custom cart templates.
    const directSelectors = [
      `[data-variant-id="${vid}"]`,
      `[data-product-variant-id="${vid}"]`,
      `[data-cart-item-variant-id="${vid}"]`,
      `[data-quantity-variant-id="${vid}"]`,
      `input[data-quantity-variant-id="${vid}"]`,
      `input[name="updates[${vid}]"]`,
      `input[id="updates_large_${vid}"]`,
      `input[id*="${vid}"]`,
    ];

    document.querySelectorAll(directSelectors.join(",")).forEach((node) => {
      if (!isLikelyCartPageElement(node)) return;

      const row = getLineItemRoot(node);
      if (row) rows.add(row);
    });

    // Fallback for Dawn-like cart pages where the input has data-index
    // or where DOM order matches cart.items order.
    if (cart && Array.isArray(cart.items)) {
      const quantityInputs = getCartPageQuantityInputs();

      cart.items.forEach((item, index) => {
        if (String(item.variant_id) !== vid) return;

        const oneBasedIndex = String(index + 1);

        const indexedInput =
          quantityInputs.find((input) => String(input.dataset.index || "") === oneBasedIndex) ||
          quantityInputs.find((input) => String(input.getAttribute("data-index") || "") === oneBasedIndex) ||
          quantityInputs.find((input) => String(input.id || "").endsWith(`-${oneBasedIndex}`)) ||
          quantityInputs.find((input) => String(input.id || "").endsWith(`_${oneBasedIndex}`)) ||
          quantityInputs[index];

        if (indexedInput) {
          const row = getLineItemRoot(indexedInput);
          if (row) rows.add(row);
        }
      });
    }

    return [...rows].filter(Boolean);
  }

  function getCartPageControlsInRow(row) {
    if (!row || !(row instanceof Element)) {
      return {
        quantityInputs: [],
        quantityButtons: [],
        removeControls: [],
      };
    }

    const quantityInputs = [
      ...row.querySelectorAll(
        [
          ".cart__qty-input",
          "input.quantity__input",
          "input[name='updates[]']",
          "input[name^='updates[']",
          "input[id^='Quantity-']",
          "input[id^='updates_']",
          "input[id^='updates_large_']",
          "input[type='number']",
          "input[type='text']",
        ].join(",")
      ),
    ];

    const quantityButtons = [
      ...row.querySelectorAll(
        [
          "button[name='minus']",
          "button[name='plus']",
          ".quantity__button",
          ".cart__qty-button",
          "[data-quantity-button]",
          "[data-action='increase']",
          "[data-action='decrease']",
          "[data-action*='quantity']",
          "button[aria-label*='increase' i]",
          "button[aria-label*='decrease' i]",
          "button[aria-label*='quantity' i]",
        ].join(",")
      ),
    ];

    const removeControls = [
      ...row.querySelectorAll(
        [
          "cart-remove-button a",
          "cart-remove-button button",
          "a[href*='/cart/change']",
          "a[href*='quantity=0']",
          "button[name='remove']",
          "button[aria-label*='remove' i]",
          "a[aria-label*='remove' i]",
          ".cart-remove-button",
          ".cart__remove",
          ".remove",
          "[data-cart-remove]",
          "[data-remove]",
        ].join(",")
      ),
    ];

    return {
      quantityInputs,
      quantityButtons,
      removeControls,
    };
  }

  function lockCartPageRow(row, variantId) {
    if (!row || !(row instanceof Element)) return;

    row.setAttribute(CART_PAGE_LOCKED_ATTR, "true");
    row.setAttribute("data-gwp-variant-id", String(variantId));
    row.classList.add("gwp-cart-page-locked");

    const { quantityInputs, quantityButtons, removeControls } = getCartPageControlsInRow(row);

    quantityInputs.forEach((input) => {
      input.readOnly = true;
      input.setAttribute("readonly", "readonly");
      input.setAttribute("aria-disabled", "true");
      input.classList.add("gwp-locked", "gwp-cart-page-locked-control");

      // Do not set disabled on quantity inputs because some cart themes depend on
      // enabled inputs for form serialization. Readonly + event-blocking is safer.
      input.addEventListener("keydown", blockCartPageGwpControlEvent, true);
      input.addEventListener("input", blockCartPageGwpControlEvent, true);
      input.addEventListener("change", blockCartPageGwpControlEvent, true);
    });

    quantityButtons.forEach((button) => {
      setControlDisabled(button, true);
      button.classList.add("gwp-cart-page-locked-control");
    });

    removeControls.forEach((control) => {
      if (control.tagName && control.tagName.toLowerCase() === "button") {
        control.disabled = true;
      }

      control.setAttribute("aria-disabled", "true");
      control.setAttribute("tabindex", "-1");
      control.classList.add("gwp-locked", "gwp-cart-page-locked-control");
    });
  }

  function lockAllCartPageGwpControls(cart) {
    for (const rule of GWP_RULES) {
      const gwpVariantId = String(rule.gwpVariantId || "");
      if (!gwpVariantId) continue;

      const rows = getCartPageRowsForVariant(gwpVariantId, cart);
      rows.forEach((row) => lockCartPageRow(row, gwpVariantId));
    }
  }

  function isCartPageGwpLockedControl(target) {
    if (!(target instanceof Element)) return false;
    if (!isLikelyCartPageElement(target)) return false;

    const lockedRow = target.closest(`[${CART_PAGE_LOCKED_ATTR}="true"]`);
    if (lockedRow) return true;

    const variantId =
      target.getAttribute("data-quantity-variant-id") ||
      target.closest("[data-quantity-variant-id]")?.getAttribute("data-quantity-variant-id") ||
      target.closest("[data-variant-id]")?.getAttribute("data-variant-id") ||
      target.closest("[data-product-variant-id]")?.getAttribute("data-product-variant-id") ||
      target.closest("[data-cart-item-variant-id]")?.getAttribute("data-cart-item-variant-id");

    if (variantId && isGwpVariantId(variantId)) return true;

    const textToCheck = [
      target.id || "",
      target.getAttribute("name") || "",
      target.getAttribute("href") || "",
    ].join(" ");

    return getAllGwpVariantIds().some((vid) => textToCheck.includes(vid));
  }

  function isCartPageQuantityOrRemoveControl(target) {
    if (!(target instanceof Element)) return false;

    return Boolean(
      target.closest(
        [
          ".cart__qty-input",
          "input.quantity__input",
          "input[name='updates[]']",
          "input[name^='updates[']",
          "input[id^='Quantity-']",
          "input[id^='updates_']",
          "input[id^='updates_large_']",
          "input[data-quantity-variant-id]",
          "button[name='minus']",
          "button[name='plus']",
          ".quantity__button",
          ".cart__qty-button",
          "[data-quantity-button]",
          "[data-action='increase']",
          "[data-action='decrease']",
          "[data-action*='quantity']",
          "button[aria-label*='increase' i]",
          "button[aria-label*='decrease' i]",
          "button[aria-label*='quantity' i]",
          "cart-remove-button a",
          "cart-remove-button button",
          "a[href*='/cart/change']",
          "a[href*='quantity=0']",
          "button[name='remove']",
          "button[aria-label*='remove' i]",
          "a[aria-label*='remove' i]",
          ".cart-remove-button",
          ".cart__remove",
          ".remove",
          "[data-cart-remove]",
          "[data-remove]",
        ].join(",")
      )
    );
  }

  function blockCartPageGwpControlEvent(event) {
    const target = event.target;

    if (!(target instanceof Element)) return;
    if (!isCartPageGwpLockedControl(target)) return;
    if (!isCartPageQuantityOrRemoveControl(target)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation?.();

    scheduleEnforcement(0, "blocked_cart_page_gwp_control");
  }

  function handleCartPageActivity(event) {
    const target = event.target;

    if (!(target instanceof Element)) return;
    if (!isLikelyCartPageElement(target)) return;

    // Hard block all cart-page GWP quantity/remove controls.
    if (isCartPageGwpLockedControl(target) && isCartPageQuantityOrRemoveControl(target)) {
      blockCartPageGwpControlEvent(event);
      return;
    }

    // If shopper changes any normal cart item/qualifier on the cart page,
    // re-check GWP caps shortly after theme/cart mutation.
    if (isCartPageQuantityOrRemoveControl(target)) {
      scheduleEnforcement(VERIFY_AFTER_CHANGE_MS, "cart_page_activity");
    }
  }

  document.addEventListener("pointerdown", handleCartPageActivity, true);
  document.addEventListener("mousedown", handleCartPageActivity, true);
  document.addEventListener("touchstart", handleCartPageActivity, true);
  document.addEventListener("click", handleCartPageActivity, true);
  document.addEventListener("keydown", handleCartPageActivity, true);
  document.addEventListener("input", handleCartPageActivity, true);
  document.addEventListener("change", handleCartPageActivity, true);

  // --------------------
  // Detect shopper opt-out for max-cap GWPs in SlideCart
  // --------------------
  const runtimeMaxByVariant = new Map();

  function findMaxRuleForElement(target) {
    if (!(target instanceof Element)) return null;

    for (const rule of GWP_RULES) {
      if (rule.syncMode !== "max") continue;

      const row = target.closest(`[data-variant-id="${String(rule.gwpVariantId)}"]`);

      if (row && isInsideSlideCart(row)) return rule;
    }

    return null;
  }

  function isDecreaseOrRemoveControl(target) {
    if (!(target instanceof Element)) return false;

    const control = target.closest("button, a");

    if (!control) return false;

    const haystack = [
      control.getAttribute("aria-label") || "",
      control.getAttribute("title") || "",
      control.textContent || "",
      String(control.className || ""),
      control.getAttribute("name") || "",
    ]
      .join(" ")
      .toLowerCase();

    return (
      haystack.includes("decrease") ||
      haystack.includes("minus") ||
      haystack.includes("remove") ||
      haystack.includes("trash") ||
      haystack.includes("delete")
    );
  }

  function isQuantityInput(target) {
    return (
      target instanceof Element &&
      target.matches("input[type='text'], input[type='number']")
    );
  }

  function handleMaxGwpUserIntent(event) {
    const target = event.target;

    if (!(target instanceof Element)) return;

    // Cart-page GWP controls are fully locked, so only SlideCart should set
    // the manual-lower opt-out flag.
    if (!isInsideSlideCart(target)) return;

    const rule = findMaxRuleForElement(target);
    if (!rule) return;

    const gwpVariantId = String(rule.gwpVariantId);

    // Use pointerdown/mousedown/touchstart as well as click so the opt-out flag is set
    // before SlideCart mutates and before our observer enforcement pass runs.
    if (
      ["pointerdown", "mousedown", "touchstart", "click"].includes(event.type) &&
      isDecreaseOrRemoveControl(target)
    ) {
      log(`${rule.name}: shopper lowered or removed GWP; session opt-out enabled`);
      setManuallyLowered(gwpVariantId, true);
      return;
    }

    if ((event.type === "input" || event.type === "change") && isQuantityInput(target)) {
      const maxQty = runtimeMaxByVariant.get(gwpVariantId) || 0;
      const enteredQty = parseInt(target.value, 10);

      // Any manual quantity entry below max opts the shopper out for this session.
      // Do NOT reset the opt-out if they later reach max again.
      if (Number.isFinite(enteredQty) && enteredQty < maxQty) {
        log(`${rule.name}: shopper entered lower GWP qty; session opt-out enabled`, {
          enteredQty,
          maxQty,
        });
        setManuallyLowered(gwpVariantId, true);
      }
    }
  }

  document.addEventListener("pointerdown", handleMaxGwpUserIntent, true);
  document.addEventListener("mousedown", handleMaxGwpUserIntent, true);
  document.addEventListener("touchstart", handleMaxGwpUserIntent, true);
  document.addEventListener("click", handleMaxGwpUserIntent, true);
  document.addEventListener("input", handleMaxGwpUserIntent, true);
  document.addEventListener("change", handleMaxGwpUserIntent, true);

  // --------------------
  // Rule enforcement
  // --------------------
  async function enforceExactRule(rule, cart) {
    const name = rule.name || "GWP";
    const qualifiers = (rule.qualifiers || []).map(String);
    const gwpVariantId = String(rule.gwpVariantId || "");
    const qtyMode = rule.qtyMode || "sum";

    const desiredQty = getAllowedQty(cart, qualifiers, qtyMode);
    const gwpItems = getVariantLines(cart, gwpVariantId);
    const currentQty = getTotalQty(gwpItems);

    if (desiredQty <= 0) {
      if (gwpItems.length) {
        log(`${name}: removing exact GWP`);
        await syncVariantLinesToQuantity(gwpItems, 0);
        return true;
      }

      return false;
    }

    if (!gwpItems.length) {
      log(`${name}: adding exact GWP qty=${desiredQty}`);
      await withRetry(() => addVariant(gwpVariantId, desiredQty));
      return true;
    }

    if (currentQty !== desiredQty || gwpItems.length > 1) {
      log(`${name}: syncing exact GWP ${currentQty} → ${desiredQty}`);
      await syncVariantLinesToQuantity(gwpItems, desiredQty);
      return true;
    }

    lockExactQuantityControls(gwpVariantId);
    return false;
  }

  async function enforceMaxRule(rule, cart) {
    const name = rule.name || "GWP";
    const qualifiers = (rule.qualifiers || []).map(String);
    const gwpVariantId = String(rule.gwpVariantId || "");
    const qtyMode = rule.qtyMode || "sum";
    const autoSyncUpToMax = rule.autoSyncUpToMax !== false;

    // Dynamic max: recalculated from cart contents every enforcement pass.
    const maxQty = getAllowedQty(cart, qualifiers, qtyMode);

    runtimeMaxByVariant.set(gwpVariantId, maxQty);

    const gwpItems = getVariantLines(cart, gwpVariantId);
    const currentQty = getTotalQty(gwpItems);
    const manuallyLowered = isManuallyLowered(gwpVariantId);

    log(`${name}: dynamic max=${maxQty}, current=${currentQty}`, {
      gwpVariantId,
      manuallyLowered,
    });

    // If no qualifiers remain, remove the GWP if present.
    // Do NOT clear manuallyLowered here. Session opt-out should persist,
    // matching AMP Slide Cart's one-auto-add-per-session behavior.
    if (maxQty <= 0) {
      if (gwpItems.length) {
        log(`${name}: removing max GWP because no qualifiers remain`);
        await syncVariantLinesToQuantity(gwpItems, 0);
        return true;
      }

      return false;
    }

    // If GWP is missing:
    // - before opt-out: add it up to max
    // - after opt-out: leave it missing
    if (!gwpItems.length) {
      if (autoSyncUpToMax && !manuallyLowered) {
        log(`${name}: adding max GWP qty=${maxQty}`);
        await withRetry(() => addVariant(gwpVariantId, maxQty));
        return true;
      }

      return false;
    }

    // Always enforce the upper cap.
    // This handles qualifier qty dropping from 3 → 2, or duplicate GWP lines.
    if (currentQty > maxQty || gwpItems.length > 1) {
      const cappedQty = Math.min(currentQty, maxQty);

      log(`${name}: reducing GWP ${currentQty} → capped qty ${cappedQty}`);
      await syncVariantLinesToQuantity(gwpItems, cappedQty);
      return true;
    }

    // Before opt-out only: auto-fill up to dynamic max.
    // After opt-out: never auto-increase again during this session.
    if (currentQty < maxQty && autoSyncUpToMax && !manuallyLowered) {
      log(`${name}: syncing GWP up ${currentQty} → dynamic max ${maxQty}`);
      await syncVariantLinesToQuantity(gwpItems, maxQty);
      return true;
    }

    // Important: do NOT reset the manual opt-out flag when currentQty reaches max.
    // Once the shopper opts out, management stays manual for the rest of the session.
    applyMaxQuantityControls(gwpVariantId, currentQty, maxQty);
    return false;
  }

  let firstEnforcement = true;
  let enforcing = false;
  let pending = false;

  async function enforceAllGwpRules({ longWait = false, reason = "unknown" } = {}) {
    if (enforcing) {
      pending = true;
      return;
    }

    enforcing = true;
    pending = false;

    try {
      log("Enforcing all GWP rules", { reason });

      const retries =
        longWait || firstEnforcement ? INITIAL_CART_READ_RETRIES : NORMAL_CART_READ_RETRIES;

      const delay =
        longWait || firstEnforcement ? INITIAL_CART_READ_DELAY : NORMAL_CART_READ_DELAY;

      const cart = await getCartWithOptionalWait(retries, delay);
      firstEnforcement = false;

      let didChange = false;

      for (const rule of GWP_RULES) {
        const gwpVariantId = String(rule.gwpVariantId || "");
        const qualifiers = rule.qualifiers || [];

        if (!gwpVariantId || !qualifiers.length) {
          warn("Skipping invalid GWP rule", rule);
          continue;
        }

        if (rule.syncMode === "max") {
          const changed = await enforceMaxRule(rule, cart);
          didChange = didChange || changed;
        } else {
          const changed = await enforceExactRule(rule, cart);
          didChange = didChange || changed;
        }
      }

      if (didChange) {
        window.SLIDECART_UPDATE?.();
        scheduleEnforcement(VERIFY_AFTER_CHANGE_MS, "verify_after_change");
      } else {
        for (const rule of GWP_RULES) {
          if (rule.syncMode === "exact") {
            lockExactQuantityControls(rule.gwpVariantId);
          }

          if (rule.syncMode === "max") {
            const gwpItems = getVariantLines(cart, rule.gwpVariantId);
            const currentQty = getTotalQty(gwpItems);
            const maxQty = getAllowedQty(cart, rule.qualifiers || [], rule.qtyMode || "sum");

            if (currentQty > 0) {
              applyMaxQuantityControls(rule.gwpVariantId, currentQty, maxQty);
            }
          }
        }

        lockAllCartPageGwpControls(cart);
      }
    } catch (e) {
      warn("GWP enforcement error", e);
    } finally {
      enforcing = false;

      if (pending) {
        pending = false;
        enforceAllGwpRules({ longWait: false, reason: "pending_rerun" });
      }
    }
  }

  // --------------------
  // Scheduling and observers
  // --------------------
  let enforceTimeout = null;

  function scheduleEnforcement(delay = ENFORCE_DEBOUNCE_MS, reason = "debounced") {
    clearTimeout(enforceTimeout);
    enforceTimeout = setTimeout(() => {
      enforceAllGwpRules({ longWait: false, reason });
    }, delay);
  }

  function getObserverTarget() {
    // Observe body so both SlideCart and the full cart page are covered.
    // Enforcement is debounced, so this should be safe.
    return document.body;
  }

  let gwpObserver = null;

  function startObserver() {
    if (gwpObserver) return;

    const target = getObserverTarget();

    gwpObserver = new MutationObserver(() => {
      scheduleEnforcement(ENFORCE_DEBOUNCE_MS, "mutation");
    });

    gwpObserver.observe(target, {
      childList: true,
      subtree: true,
    });

    log("GWP observer started", {
      target: "body",
    });
  }

  function init() {
    startObserver();

    enforceAllGwpRules({
      longWait: true,
      reason: "init",
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();